export default "__VITE_ASSET__BdR9sbSR__"